module.exports = __webpack_public_path__ + "static/media/tick.4d0e125a.svg";